export default __webpack_public_path__ + "static/media/FNT_logoMain.70dd7b80.png";